module.exports = __webpack_public_path__ + "media/yolo-3.0/MenuBtn-d1c198bb.svg";